import React, { useMemo } from 'react';
import './Style/FWE.scss';
import Link from 'antd/lib/typography/Link';
import { IFolder, ITenant } from '../../../../api/FileEndPoint';

interface IFWEPointOrigin {
  tenant: ITenant;
  folder: IFolder;
}

interface IProps {
  fwePointOrigin: IFWEPointOrigin;
  coordinates: Array<number>;
  fweUrl: string;
  name?: string;
  createNewPoint: (coordinates: Array<number>, name?: string) => void;
}

export default function FWEPointPopupContent(props: IProps) {
  const { fwePointOrigin, coordinates, fweUrl, createNewPoint , name} = props;

  const fweLink = useMemo(() => {
    // ToDo: Once backend is ready:
    // To activate "See in FWE" link user needs to be member of fwePointOrigin.tenant and have read access to fwePointOrigin.folder
    // --> MOOD backend will filter out points outside of user's tenant
    // --> MOOD backend will provide an endpoint returning project capabilities
    // this endpoint needs to be called and deactivate the fweLink if user has no access rights to the folder
    return fweUrl + '/project/' + fwePointOrigin.folder.id + '?tenantId=' + fwePointOrigin.tenant.id
  }, [fweUrl, fwePointOrigin])

  return (
    <div className="fwe-popup-content">
      <div className="title"><b>{name}</b></div>
      <div>{fwePointOrigin.folder.name}</div>
      <div className="coordinates">
        <div>Long {Math.round(coordinates[0] * 10000) / 10000}</div>
        <div className="leftPadding">Lat {Math.round(coordinates[1] * 10000) / 10000}</div>
      </div>
      <Link
        href={fweLink}
        target="_blank"
        rel="noopener"
        className="fweLink"
      >
        {'See in MIKE MS'}
      </Link>
      <div className="createPointButtonContainer">
        <button className="button" onClick={() => createNewPoint(coordinates, name)}>{"New point in this location"}</button>
      </div>

    </div>
  );
}
